const commonSteps = (contractType) => [
    { name: 'Conditions', target: `conditions/${contractType}` },
    { name: 'Souscription', target: `overview/${contractType}` },
    { name: 'Informations', target: `informations/${contractType}` },
];

const pvpSteps = (contractType) => [
    { name: 'Justificatifs', target: `documents/${contractType}` },
    { name: 'Signature', target: `signatures/${contractType}` },
];

const targetSteps = (contractType) => [
    { name: 'Docs internes', target: `internalDocs/${contractType}` },
    { name: 'Signature', target: `signatures/${contractType}` },
    { name: 'Hub Primonial', target: `lifeInsuranceHub/${contractType}` },
];

const mmaSteps = (contractType) => [
    { name: 'Docs internes', target: `internalDocs/${contractType}` },
    { name: 'Signature', target: `signatures/${contractType}` },
    { name: 'Extranet', target: `lifeInsuranceHub/${contractType}` },
];

const getWizard = (contractType) => {
    const getSpecificSteps = () => {
        if (contractType.includes('pvp') || contractType.includes('pvpImmo')) {
            return pvpSteps(contractType);
        }
        if (contractType.includes('mma')) {
            return mmaSteps(contractType);
        }

        return targetSteps(contractType);
    };

    return {
        prefixTemplate: ({ id, contractId }) => `/rip/${id}/contracts/${contractId}`,
        items: [
            ...commonSteps(contractType),
            ...getSpecificSteps(),
        ],
    };
};

export default getWizard;
